import { ReactNode } from 'react';

import { ValuationLayoutWrapper } from './styles';

function ValuationLayout({ children }: ValuationLayoutProps) {
  return (
    <ValuationLayoutWrapper>
      <main className="valuation-main">{children}</main>
    </ValuationLayoutWrapper>
  );
}

type ValuationLayoutProps = {
  children: ReactNode;
};

export default ValuationLayout;
